import api from "./core";
const config = require("./serverCfg").default;

const basePath = "api/{{serverSegment}}/DocumentGroups";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(formId, clientId, eocId) {
    return api.post(`${basePath}/ByEoc/${formId}/${eocId}`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  viewUrl(id) {
    return `${api.getFormsBaseUrl()}${basePath}/Download/${api.getToken()}/${id}`;
  },
  documentGroupsFromIds(ids) {
    return api.post(`${basePath}/DocumentGroupsFromIds`, ids);
  },
  documentGroupsResultsIds(ids) {
    return api.post(`${basePath}/DocumentGroupsResultsIds`, ids);
  },
  documentGroupViewUrl(documentGroupId) {
    return {
      url: `${
        config.coreBaseUrl
      }${basePath}/RenderDocumentGroup/${documentGroupId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  },
  downloadDocumentGroupPdf(id) {
    return fetch(`${config.coreBaseUrl}${basePath}/DownloadDocumentGroupPdf`, {
      method: "POST",
      body: JSON.stringify(id),
      headers: {
        "Content-Type": "application/json"
      }
    });
  },
  upload(data) {
    const { file, clientId, date, eocId, status, formGroupId } = data;
    const formData = new FormData();
    formData.append("File", file);
    formData.append("PatientId", clientId);
    formData.append("FormGroupId", formGroupId);
    formData.append("EffectiveDate", date);
    formData.append("EpisodeOfCareId", eocId);
    formData.append("Status", status);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return api.put(`${basePath}/upload`, formData, config);
  },
  uploadUpdate(data) {
    const { file, date, submitId, status, formGroupId, unlockReason } = data;
    const formData = new FormData();
    if (file) formData.append("File", file);
    formData.append("EffectiveDate", date);
    formData.append("Status", status);
    formData.append("FormGroupId", formGroupId);
    formData.append("UnlockReason", unlockReason);
    if (submitId) formData.append("id", submitId);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return api.patch(`${basePath}/upload`, formData, config);
  },
};
